import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import {
  faqLegalCopy,
  idmeFaqLegalCopy,
  getEnrolledGroupedFAQs,
  getUnenrolledGroupedFAQs,
} from '../../../constants/constants';
import { Section } from './section';

/* `apiResponse` is still what says the page has loaded - there is nothing to
/* show before it arrives - but which set of FAQs to show comes from `isEnrolled`,
/* which the page resolves for the whole page at once. Reading enrollment off the
/* response here as well would put the "how to enroll" FAQs under a section
/* congratulating a customer who just verified. */
function FAQs({ apiResponse, isEnrolled }) {
  const isTCChangesEnabled = !!useConfigService('ENABLE_TC_CHANGES');
  const enableHdPass = !!useConfigService('ENABLE_HD_PASS_VERBIAGE');
  const isIdmeEnabled = !!useConfigService('ENABLE_MILITARY_VERIFICATION_IDME');

  const faqOptions = { enableHdPass, isIdmeEnabled };
  const faqs = isEnrolled
    ? getEnrolledGroupedFAQs(faqOptions)
    : getUnenrolledGroupedFAQs(faqOptions);
  const legalCopy = isIdmeEnabled
    ? idmeFaqLegalCopy()
    : faqLegalCopy(isTCChangesEnabled);

  return (
    <div id="faqs">
      {apiResponse &&
        faqs.map((item, indx) => (
          <Section key={item.title} section={item} index={indx} />
        ))}
      <Typography variant="body-xs">{legalCopy}</Typography>
    </div>
  );
}

FAQs.propTypes = {
  apiResponse: PropTypes.shape({
    enrollmentStatus: PropTypes.string,
    isMilitaryDiscountCapped: PropTypes.string,
    enrolledProfile: PropTypes.objectOf(PropTypes.string),
  }).isRequired,
  isEnrolled: PropTypes.bool,
};

FAQs.defaultProps = {
  isEnrolled: false,
};

export default FAQs;
